import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  Output,
  EventEmitter,
} from '@angular/core';
import { LeafAngularWrapper } from '../leaf-angular-wrapper';

import '@cigna/leaf-web/lib/wc/components/tab/tab';

@Component({
  selector: 'cigna-leaf-tab',
  template: `
    <leaf-tab (tabSelected)="tabSelected.emit($event.detail?.index)">
      <ng-content></ng-content>
    </leaf-tab>
  `,
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CignaLeafTabComponent extends LeafAngularWrapper {
  @Output() tabSelected = new EventEmitter<number>();
}
